export default __webpack_public_path__ + "static/media/working08.0b0fa94d.png";